import { useProgramDependentDataContext } from '@/app/core/components/program-wizard/program-dependent-data-context';
import { ClientAttributes } from '@ssar-app/domain';
import { ReactNode, Fragment } from 'react';

interface OrderDetailsFetcherProps {
  subCode: string;
  onSuccess: (clientAttributes: ClientAttributes) => ReactNode;
  onError: (error: Error) => void;
}
export const OrderDetailsFetcher = (props: OrderDetailsFetcherProps) => {
  const { onSuccess: onSuccessResponse } = props;
  const { data } = useProgramDependentDataContext();

  return (
    <Fragment>
      {onSuccessResponse(
        data && data?.clientAttributesModel
          ? data?.clientAttributesModel?.clientAttributes
          : {},
      )}
    </Fragment>
  );
};
